import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { PaymentsInReview } from "../../../Common/Review/Component/PaymentsInReview";
import { FinancialAdviceReview } from "../../../Common/Review/Component/FinancialAdviceReview";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { InvestmentReview } from "../../../Common/Review/Component/InvestmentReview";
import { DrawdownReview } from "../../../Common/Review/Component/DrawdownReview";
import { IncomePaymentReview } from "../../../Common/Review/Component/IncomePaymentReview";
import { Urls } from "../../../../../Urls";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { hasEnhancedPensionProtection } from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { BWACheck } from "../../../Common/Review/Component/BWACheck";

interface IReviewProps extends IProcessComponentProps {
    data: PensionContributionModel;
    type: SubAccountType;
}

interface IReviewState {}

export class Review extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getReviewProps = (data, subAccountType) => {
        return {
            data: data,
            subAccountType: subAccountType,
            process: ProcessType.TopUpWithITFLS,
            colNum: 3,
            extraInfo: data,
        };
    };

    isIncomePaymentShow = (): boolean => {
        return this.props.data?.Contribution?.DrawdownModel?.Income?.TaxableIncomeRequiredInAddition;
    };

    render() {
        const { data, type } = this.props;
        const contribution = data.Contribution;
        return (
            <>
                <h2 className="mb-24">Review</h2>
                <FinancialAdviceReview {...this.getReviewProps(contribution, type)} disableEdit={true} />
                <BWACheck extraInfo={data} />
                <PaymentsInReview isOpen={true} {...this.getReviewProps(contribution, type)} />
                <InvestmentReview
                    {...this.getReviewProps(contribution, type)}
                    ownerHierarchyId={HierarchyIdHelper.generateHierarchyId(this.props.data.HierarchyId).entityId}
                />
                <DrawdownReview
                    {...this.getReviewProps(contribution, type)}
                    showDrawdownPriceLock={true}
                    showAssetsToSell={false}
                    modelData={data}
                    isImmediateLumpSum={true}
                    onEditAction={() =>
                        Navigator.navigateToAndPreserveQueryParameters(Urls.get().TopUpWithITFLSDrawdown)
                    }
                    hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                />
                {this.isIncomePaymentShow() && (
                    <IncomePaymentReview
                        {...this.getReviewProps(contribution, type)}
                        model={data}
                        onEditAction={() =>
                            Navigator.navigateToAndPreserveQueryParameters(Urls.get().TopUpWithITFLSIncomePayment)
                        }
                        isITFC={true}
                    />
                )}
            </>
        );
    }
}
